<template>
  <b-modal id="Refresh" hide-footer>
    <template #modal-title> New Version Of Honeycomb Available </template>
    <div class="d-block">
      <label for="" class="pr-1">Current Version: </label>
      <span> {{ releaseBotUiVersion }} </span>
    </div>
    <div class="d-block">
      <label for="" class="pr-1">Loaded Version: </label>
      <span> {{ uiVersion }} </span>
    </div>
    <div class="d-block text-center mt-1">
      <h5>Please refresh the page.</h5>
    </div>
    <div class="d-block text-center mt-1">
      <b-button class="" size="sm"
        ><a @click="hardRefresh">Refresh</a></b-button
      >
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RefreshModal",

  computed: {
    ...mapState({
      releaseVersions: (state) => state.customers.releaseVersions,
    }),

    releaseBotHoneycombDeployment() {
      if (this.releaseVersions && this.releaseVersions.Groups) {
        let coreDeployments = this.releaseVersions.Groups.find(
          (group) => group.Group === "CORE"
        );
        if (coreDeployments) {
          return coreDeployments.Deployments.find(
            (deployment) => deployment.Bot === "Honeycomb"
          );
        }
      }
      return null;
    },

    releaseBotUiVersion() {
      if (
        this.releaseBotHoneycombDeployment &&
        this.releaseBotHoneycombDeployment.Branch
      )
        return `${this.releaseBotHoneycombDeployment.Branch.replaceAll(
          /[a-z-]/g,
          ""
        )}.${this.releaseBotHoneycombDeployment.Build}`;
      else return null;
    },

    uiVersion() {
      return require("../../../package.json").version;
    },

    isOldVersion() {
      return (
        this.releaseVersions &&
        this.releaseBotUiVersion &&
        process.env.NODE_ENV !== "development" &&
        this.releaseBotUiVersion !== this.uiVersion
      );
    },

    currentPage() {
      return this.$route.path;
    },
  },

  mounted() {
    this.openModal();
  },

  updated() {
    this.openModal();
  },

  watch: {
    currentPage() {
      this.openModal();
    },
  },

  methods: {
    openModal() {
      // if (this.isOldVersion) this.$bvModal.show("Refresh");
    },

    hardRefresh() {
      location.reload(true);
    },
  },
};
</script>